import React from 'react';

import { useIntl } from 'react-intl';

import { IBaseProps } from '@rbi-ctg/frontend';
import { IPaymentMethod } from 'state/payment/types';

import { MethodType, MethodTypeEmailPaypal } from './styled';

interface IPrepaidMethodBalance extends IBaseProps {
  method: IPaymentMethod;
}

const PayPalMethod = ({ method }: IPrepaidMethodBalance) => {
  const { formatMessage } = useIntl();
  const isVaulted = method.accountIdentifier !== 'PAYPAL';

  if (isVaulted && method.paypalIdentifier) {
    return <MethodTypeEmailPaypal>{method.paypalIdentifier}</MethodTypeEmailPaypal>;
  }

  return (
    <MethodType>
      {isVaulted
        ? formatMessage({ id: 'payWithPayPal' })
        : formatMessage({ id: 'addNewPaymentMethodPayPal' })}
    </MethodType>
  );
};

export default PayPalMethod;
